import React, { useContext, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { WebSocketContext } from "../context/WebSockectContext";
import '../styles/userProfile.css';
import api from '../context/api';

export const UserProfile = ({ token, userData, setUserData, setUserBalance, setWinBalance }) => {
  const { serverMessage } = useContext(WebSocketContext);
  const navigate = useNavigate();

  const isPWA = useMemo(() => {
    if (typeof window === "undefined") return false;
    const isStandalone = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
    const isNavigatorStandalone = window.navigator.standalone === true;
    return !!(isStandalone || isNavigatorStandalone);
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await api.get('/user');
      const nextUserBalance = Number(response.data?.balance ?? response.data?.userBalance ?? 0);
      const nextWinBalance = Number(response.data?.winBalance ?? 0);

      setUserData((prev) => ({
        ...(prev || {}),
        fullName: response.data?.fullName || "",
        phoneNumber: response.data?.phoneNumber || "",
        userBalance: Number.isFinite(nextUserBalance) ? nextUserBalance : 0,
        winBalance: Number.isFinite(nextWinBalance) ? nextWinBalance : 0,
      }));
      setUserBalance(Number.isFinite(nextUserBalance) ? nextUserBalance : 0);
      if (typeof setWinBalance === 'function') {
        setWinBalance(Number.isFinite(nextWinBalance) ? nextWinBalance : 0);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
    const intervalId = setInterval(fetchUserData, 2000);
    return () => clearInterval(intervalId);
  }, [token, setUserData, setUserBalance, setWinBalance]);

  useEffect(() => {
    if (serverMessage && serverMessage.type === "balanceUpdate") {
      setUserBalance(serverMessage.newBalance);
      alert(`Your new balance is ${serverMessage.newBalance}`);
    }
  }, [serverMessage, setUserBalance]);

  return (
    <div>
      {userData && (
        <div className="wallet-card" onClick={() => navigate("/deposit")}>
          <div className="balance" >

            {!isPWA && (
              <span className="amount">
                {userData.fullName ? userData.fullName.slice(0, 7) : ""}
              </span>
            )}
           
          </div>
           <div className="username" >
              GH₵ {userData.userBalance !== undefined ? userData.userBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
            </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
